import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  user: null,
  accessToken: '',
  error: null,
  loginStatus: false,
};
 const apiUrl = process.env.REACT_APP_API_URL;

export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ password, phone,fcm_token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl + "auth/login", {
        password,
        phone,
        fcm_token,
        headers: {
         "Content-Type": "application/json",
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

export const refreshFcm = createAsyncThunk(
  "auth/refreshFcm",
  async ({ phone,fcm_token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(apiUrl + "auth/refresh-fcm-token", {
        phone,
        fcm_token,
        headers: {
         "Content-Type": "application/json",
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Fcm tocken refresh failed");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: () => initialState,
    resetAuth: (state) => {
      state.user = null;
      state.accessToken = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loginStatus = true;
        state.user = action.payload.user;
        state.accessToken = action.payload.token;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loginStatus = false;
        state.error = action.payload;
      });
  },
});

export const { logout, resetAuth } = authSlice.actions;
export default authSlice.reducer;
